module.exports = __webpack_public_path__ + "static/media/CourtSeal-no-back.a0bacf1a.png";